<template>
  <div class="grid-container full">
    <div class="grid-x readyBox page-contents-15">
      <div class="small-12 medium-auto cell">
        <h2>{{ raresSupport }}</h2>
        <p>CANDIDATES RATE RARE’S SUPPORT AS EXCELLENT</p>
      </div>
      <div class="small-12 medium-auto cell">
        <h2>{{ hiredAfterArticles }}</h2>
        <p>*MORE LIKELY TO GET HIRED AFTER ‘ARTICLES’</p>
      </div>
      <div class="small-12 medium-auto cell">
        <h2>{{ hiredAfterConsult }}</h2>
        <p>*MORE LIKELY TO GET HIRED AFTER ‘CONSULT’</p>
      </div>
      <div class="small-12 medium-auto cell">
        <h2>{{ employers }}</h2>
        <p>TOP EMPLOYERS USE RARE’S CRS WORLDWIDE</p>
      </div>
      <div class="small-12 medium-auto cell">
        <h2>{{ disadvantagedCandidatesHired }}</h2>
        <p>more disadvantaged candidates hired</p>
      </div>
    </div>
    <div class="grid-x">
      <div class="small-12 cell text-center">
        <p class="approximateCalc">*APPROXIMATE CALCULATIONS</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareCandidatesContexulised',
  props: {
    raresSupport: {
      type: String,
    },
    hiredAfterArticles: {
      type: String,
    },
    hiredAfterConsult: {
      type: String,
    },
    employers: {
      type: String,
    },
    disadvantagedCandidatesHired: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: $dark-grey-background;
  }

  h2
  {
    color: $green-highlight;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  p {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
    text-align: center;
  }

  @media only screen and (max-width: 1120px)  {
    .page-contents-15 {
      padding: 05% !important;
    }
  }

  @media only screen and (max-width: 640px)  {

    .approximateCalc {
      font-size: 10px;
      margin-bottom: 15px;
      letter-spacing: 1.5px;
    }


    h2 {
      font-size: 64px;
      line-height: 1;
      letter-spacing: normal;
      margin: 20px 0 20px 0;
    }

    p {
      font-size: 14px;
      line-height: 1.71;
      letter-spacing: 2px;
      margin: 20px 0 75px 0;
    }
    .top {
      margin-top: 43px;
    }

    .bottom {
      margin-bottom: 43px;
    }
  }

  @media only screen and (min-width: 641px) {

    .approximateCalc {
      font-size: 12px;
      margin-bottom: 15px;
    }

    h2 {
      font-size: 48px;
      line-height: 1;
      letter-spacing: normal;
      margin: 75px 0 10px 0;
    }

    p {
      font-size: 14px;
      line-height: 1.25;
      letter-spacing: 2px;
      margin: 20px 0 30px 0;
      padding: 0 16px;
    }

    .top {
      margin-top: 75px;
    }

    .bottom {
      margin-bottom: 75px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesDataRow.vue